
<div class="bi-action container cbi-action">
  <div>
    <div class="container">
      <div class="row">
        <div class="label mt-2 mb-1 mr-1" v-b-tooltip="'Last update: ' + action.lastUpdate">
          {{ action.name }}
          <i
            v-if="action.isLiveData"
            @click="refreshAction(action.id)"
            class="cursor-pointer fas fa-sync ml-1"
            :class="{ 'fa-spin': loading }"
          ></i>
        </div>
        <div v-if="action.error" class="ml-3 badge badge-danger badge-pill notransition" v-b-popover.hover="action.error">Error</div>
      </div>
    </div>
  </div>

  <ActionResultData :action="action"></ActionResultData>

  <div v-if="action.type === actionType.Get">
    <BoardItemGetAction :action="action"></BoardItemGetAction>
  </div>
  <div v-if="action.type === actionType.Post">
    <BoardItemPostAction :action="action"></BoardItemPostAction>
  </div>
</div>
